module.exports = __webpack_public_path__ + "static/media/apple-color.8da2561d.svg";